import { CloudArrowUpIcon } from '@heroicons/react/24/outline';
import { PropsWithChildren } from 'react';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import { useOrganization } from '@/hooks/useOrganization';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * LAX-10042: the "no data model uploaded / no layout defined" empty state,
 * extracted from `DataModelDependentPage` so callers that need to render
 * the same empty state under a different condition (e.g. `!dataModel.
 * hasLayout('browse')` in `browse.tpl.html`) can reuse it without hacking
 * `DataModelDependentPage`'s children contract.
 */
const NoDataModelEmptyState = () => {
    const { t } = useTranslation();
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-52 tw-space-y-7">

            <Icon size="3xl" icon={CloudArrowUpIcon} />

            <h1>{t('NODATA.NO_DATAMODEL_HEADLINE')}</h1>

            <Button onClick={() => location.href = '/datamodelexchange'} >
                {t('NODATA.NO_DATAMODEL_BUTTON')}
            </Button>

        </div>
    );
};

NoDataModelEmptyState.DisplayName = 'NoDataModelEmptyState';

const DataModelDependentPage = ({ children }: PropsWithChildren) => {

    const { organization } = useOrganization();

    if (!organization?.dataModelHash) {
        return <NoDataModelEmptyState />;
    } else {
        return children;
    }

};

DataModelDependentPage.DisplayName = 'DataModelDependentPage';

export { DataModelDependentPage, NoDataModelEmptyState };
